import { updatesData } from '@/mocks/homeData';

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading font-bold text-2xl md:text-3xl lg:text-4xl text-foreground-950 mb-3">
            最新动态
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
            漫画世界的最新变化，一口气全知道
          </p>
        </div>

        <div className="max-w-3xl mx-auto relative">
          <div className="absolute left-3 md:left-4 top-2 bottom-2 w-0.5 bg-background-300 rounded-full"></div>

          <div className="flex flex-col gap-0">
            {updatesData.map((item, i) => (
              <div key={i} className="relative flex items-start gap-4 md:gap-6 pl-10 md:pl-12 py-4 md:py-5 group">
                <div className="absolute left-[7px] md:left-[9px] top-5 w-2.5 h-2.5 md:w-3 md:h-3 rounded-full border-2 border-background-100 bg-primary-500 z-10 group-hover:scale-125 transition-transform"></div>

                <span className="text-xs font-medium text-foreground-400 whitespace-nowrap mt-0.5 min-w-[70px] md:min-w-[80px]">
                  {item.date}
                </span>

                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 flex-wrap mb-1">
                    <span className={`inline-block px-2 py-0.5 rounded text-[10px] md:text-xs font-medium whitespace-nowrap ${
                      item.tag === '最新' ? 'bg-primary-100 text-primary-700' :
                      item.tag === '热门' ? 'bg-accent-100 text-accent-800' :
                      item.tag === '活动' ? 'bg-secondary-100 text-secondary-800' :
                      item.tag === '功能' ? 'bg-background-200 text-foreground-600' :
                      item.tag === '专访' ? 'bg-accent-100/60 text-accent-700' :
                      'bg-primary-100/70 text-primary-600'
                    }`}>
                      {item.tag}
                    </span>
                  </div>
                  <p className="text-sm md:text-base text-foreground-800 leading-relaxed group-hover:text-foreground-950 transition-colors">
                    {item.title}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}